import { all, call, put } from 'redux-saga/effects';

import { isProduction } from 'src/util/environments';
import { Store, setScreenData, getScreenData, getModuleConfig } from 'cw-ui-core';
import forEach from 'lodash/forEach';
import values from 'lodash/values';
import size from 'lodash/size';
import get from 'lodash/get';
import { toMap } from 'src/util/Util';
import { GET, getHeaders, getPartnerId } from '../services/ApiService';

// feature flags for transitining towards new UI look
// feature name should follow this naming convention NEW_<TAB_NAME>_FEATURE
export const Features = {
    NEW_IDENTITY_ROLES_FEATURE: 'hasNewIdentityRolesFeature',
    NEW_USERS_FEATURE: 'hasNewUsersFeature',
    NEW_PRODUCTS_FEATURE: 'hasNewProductsFeature',
    USERS_ASSIGNED_TO_ROLE: 'hasShowUsersAppRoleFeature',
    USERS_ASSIGNED_TO_ROLE__READ_ONLY: 'hasShowUsersAppRoleReadOnlyFeature',
    RESOURCES_ASSIGNMENT_FEATURE: 'hasResourcesAssignmentFeature',
    CONTENT_ASSIGNMENT_FEATURE: 'hasContentAssignmentFeature',
    CORPORATE_STRUCTURE: 'hasCorporateStructureFeature',
    RESOURCES_ASSIGNMENT_FEATURE_SUBSCRIBERS: 'hasResourcesAssignmentForSubscriberFeature',
    BULK_USER_ASSIGNMENT: 'hasBulkUserAssignment',
};

const getUrl = () =>
    !isProduction()
        ? 'https://api-cwservices-na.connectwisedev.com/skylab/'
        : 'https://api-cwservices-na.myconnectwise.net/skylab/';

export function* loadFeature(featureId) {
    const result = yield call(GET, `${getUrl()}features/${featureId}/partners/${getPartnerId()}`, getHeaders());

    // log any errors and treat as feature being disabled
    if (!result.isSuccess) {
        result.response = { featureInactiveFlag: true, inactiveFlag: true };
    }

    yield put(setScreenData(['features', featureId], result.response, 'SkyLab'));
    return result.response;
}

export function* getAllFeatures() {
    const features = {};
    const calls = [];
    const ids = [];
    forEach(values(Features), ({ id }) => {
        calls.push(call(GET, `${getUrl()}features/${id}/partners/${getPartnerId()}`, getHeaders()));
        ids.push(id);
    });

    const results = yield all(calls);
    for (let i = 0; i < size(results); i += 1) {
        if (!get(results[i], 'isSuccess', false)) {
            results[i].response = { featureInactiveFlag: true, inactiveFlag: true, featureId: ids[i] };
        }

        const featureId = get(results[i], 'response.featureId');
        yield put(setScreenData(['features', featureId], results[i].response, 'SkyLab'));
        features[featureId] = results[i].response;
    }

    yield put(setScreenData(['loaded'], true, 'SkyLab'));
    return features;
}

export function* loadFeatures() {
    const result = yield call(GET, `${getUrl()}partners/${getPartnerId()}/features`, getHeaders());

    if (!result.isSuccess) {
        result.response = [];
    }

    yield put(setScreenData(['partnerFeatures'], result.response, 'SkyLab'));
}

export function getFeature(featureId) {
    return getScreenData(Store().getState().screen, ['features', featureId], 'SkyLab')?.toJS();
}

export function hasFeature(featureId) {
    const config = toMap(getModuleConfig(Store().getState().module));
    const isFeatureAvailable = get(config, [featureId], false);
    return Boolean(isFeatureAvailable);
}
